import { parseCookies, setCookie, destroyCookie } from './nookies';

/*
 * В запросе может быть только один заголовок Set-Cookie
 * Поэтому нужно объединять все Cookies в один запрос
 */

const DEFAULT_EXPIRES = 30 * 24 * 60 * 60;

class Ncookies {
  constructor(ctx, expires = DEFAULT_EXPIRES, path = '/') {
    this.ctx = ctx;
    this.expires = expires;
    this.path = path;
  }

  set(key, value, stringifyJSON = false) {
    setCookie(this.ctx, key, stringifyJSON ? JSON.stringify(value) : value, {
      maxAge: this.expires,
      path: this.path,
    });
  }

  get(key, parseJSON = false) {
    const parse = parseCookies(this.ctx);
    return parseJSON ? (parse && parse[key] ? JSON.parse(parse[key]) : null) : parse[key] || null;
  }

  remove(key) {
    destroyCookie(this.ctx, key, {
      path: this.path,
    });
  }
}

export default Ncookies;



// WEBPACK FOOTER //
// helpers/ncookies.js